import React, { Component } from 'react';
//import {
//    NavLink, NavbarBrand,
//    Collapse, Navbar, NavItem, Col, Container, Row
//} from 'reactstrap';
import carouselImg from "../assets/img/carousel-1.jpg";
import carouselIm from "../assets/img/carousel-2.jpg";
import aboutusImg from "../assets/img/about.jpg";

export class Home extends Component {
    static displayName = Home.name;

    render() {
        return (
            <div>

                <div class="container-fluid my-carousel position-relative p-0">
                    <div id="header-carousel" class="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div class="carousel-inner">
                            <div class="carousel-item active">
                                <img class="w-100" src={carouselImg} alt="my_image" />
                                <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                    <div class="p-3">
                                        <p class="text-white text-uppercase mb-2 animated slideInDown">develop, innovate & inspire</p>
                                        <h1 class="display-6 text-capitalize text-white mb-md-4 animated zoomIn">CCTV Networking IT Infrastructure Consultation</h1>
                                        <p class="btn my-btn btn-outline-primary py-md-3 px-md-5 me-3 animated slideInLeft">Innovation</p>
                                        <p class="btn my-btn btn-outline-primary py-md-3 px-md-5 animated slideInRight">Inspiration</p>
                                    </div>
                                </div>
                            </div>
                            <div class="carousel-item">
                                <img class="w-100" src={carouselIm} alt="my_mage" />
                                <div class="carousel-caption d-flex flex-column align-items-center justify-content-center">
                                    <div class="p-3">
                                        <p class="text-white text-uppercase mb-2 animated slideInDown">develop, innovate & inspire</p>
                                        <h1 class="display-6 text-capitalize text-white mb-md-4 animated zoomIn">Virtualization Storage Backup & Replication</h1>
                                        <p class="btn btn-outline-primary py-md-3 px-md-5 me-3 animated slideInLeft">Innovation</p>
                                        <p class="btn btn-outline-primary py-md-3 px-md-5 animated slideInRight">Inspiration</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="carousel-control-prev" type="button" data-bs-target="#header-carousel"
                            data-bs-slide="prev">
                            <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Previous</span>
                        </button>
                        <button class="carousel-control-next" type="button" data-bs-target="#header-carousel"
                            data-bs-slide="next">
                            <span class="carousel-control-next-icon" aria-hidden="true"></span>
                            <span class="visually-hidden">Next</span>
                        </button>
                    </div>
                </div>

                {/*<!-- Facts Start -->*/}
                <div class="container-fluid facts py-2 pt-lg-0">
                    <div class="container py-5 pt-lg-0">
                        <div class="row gx-0">
                            <div class="col-lg-4 wow zoomIn" data-wow-delay="0.1s">
                                <div class="bg-light shadow d-flex align-items-center justify-content-center p-4">
                                    <div class="bg-white d-flex align-items-center justify-content-center rounded mb-2">
                                    </div>
                                    <div class="ps-2 py-3 text-center">
                                        <p class="text-primary text-uppercase mb-0">our goal</p>
                                        <p class="text-primary mb-0">To promote innovation, enhance decision-making & improve security</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 wow zoomIn" data-wow-delay="0.3s">
                                <div class="bg-primary shadow d-flex align-items-center justify-content-center p-4">
                                    <div class="bg-primary d-flex align-items-center justify-content-center rounded mb-2">
                                    </div>
                                    <div class="ps-2 py-3 text-center">
                                        <p class="text-light text-uppercase mb-0">our vision</p>
                                        <p class="text-light mb-0">To innovate inspire and create endless opportunities</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4 wow zoomIn" data-wow-delay="0.6s">
                                <div class="bg-light shadow d-flex align-items-center justify-content-center p-4">
                                    <div class="bg-white d-flex align-items-center justify-content-center rounded mb-2">
                                    </div>
                                    <div class="ps-2 py-3 text-center">
                                        <p class="text-primary text-uppercase mb-0">our mission</p>
                                        <p class="text-primary mb-0">Promote tech awareness & improve service delivery in the society</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*<!-- Facts Start -->*/}

                {/*about us section starts here*/}
                <div class="container-fluid py-2 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="container py-5">
                        <div class="row g-5">
                            <div class="col-lg-6 my-par">
                                <div class="section-title position-relative pb-2 mb-3">
                                    <h5 class="fw-bold text-primary text-uppercase">about us</h5>
                                    <h1 class="mb-0 text-uppercase">know more about jewstechs</h1>
                                </div>
                                <p class="my-2">
                                    Jewstechs is an <span className="text-primary">ICT infrastructure and networking</span> company
                                    focused on delivering reliable, scalable, and secure technology solutions that meet business needs.
                                    Our team designs, deploys, and maintains enterprise IT environments tailored to your requirements.
                                    We provide professional networking solutions for businesses, schools, hospitals, warehouses, and
                                    organizations of all sizes.
                                </p>

                                <p class="my-2">
                                    Our expertise extends to <span className="text-primary">CCTV surveillance, access control, and
                                        security systems</span>. We install and configure high-quality surveillance cameras, biometric access
                                    control, and integrated security solutions for homes, offices, schools, hospitals, warehouses, and
                                    commercial premises. We also offer <span className="text-primary">remote monitoring, system maintenance,
                                        and preventive support</span> to ensure your security infrastructure operates efficiently at all times.
                                </p>

                                <p class="my-2">
                                    We specialize in <span className="text-primary">IT infrastructure management and ICT consultation</span>,
                                    including virtualization, enterprise storage, backup and replication solutions, server deployment,
                                    infrastructure optimization, and disaster recovery planning. Our experienced team helps organizations
                                    build resilient, high-performing IT environments while providing expert consultation to support business
                                    growth and digital transformation.
                                </p>

                                <p class="btn my-btn btn-outline-primary py-3 px-5 mt-3 text-capitalize wow zoomIn" data-wow-delay="0.9s">
                                    networking, IT infrastructure & security systems
                                </p>
                            </div>
                            <div class="col-lg-6">
                                <div class="position-relative h-100">
                                    <img class="position-absolute w-100 h-100 rounded wow zoomIn" data-wow-delay="0.9s" src={aboutusImg} alt="my_mage" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*about us section ends here*/}

                {/*<!--parallax section starts here-->*/}
                <div class="footer-main">
                    <div class="footer-news pad-top-100 pad-bottom-70 parallax">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="parallax-div py-5 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">

                                    </div>
                                </div>
                                {/*<!-- end col -->*/}
                            </div>
                            {/*<!-- end row -->*/}
                        </div>
                        {/*<!-- end container -->*/}
                    </div>
                </div>
                {/*<!--parallax section starts here-->*/}

                {/*why us section starts here*/}
                <div class="container-fluid py-2 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="container py-5">

                        <div class="row g-5 my-1">
                            <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                <div class="section-title position-relative pb-2 mb-2">
                                    <h5 class="fw-bold text-primary text-uppercase">why us</h5>
                                    <h1 class="mb-0 text-uppercase">why choose jewstechs</h1>
                                    <p className="text-uppercase">grow and develop innovation in business</p>
                                </div>
                            </div>
                        </div>

                        <div class="row g-5">
                            <div class="col-lg-4 my-par">

                                <div class="row g-3 my-1">
                                    <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                        <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                            <i class="bi bi-clock text-white"></i>
                                        </div>
                                        <div className="col-10 mb-1 mx-2">
                                            <p className="text-uppercase fw-bolder my-0">24/7 services</p>
                                            <p className="mb-0 my-0">Readily available services</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="row g-3 my-1">
                                    <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                        <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                            <i class="bi bi-people text-white"></i>
                                        </div>
                                        <div className="col-10 mb-1 mx-2">
                                            <p className="text-uppercase fw-bolder my-0">group work and collaboration</p>
                                            <p className="mb-0 my-0">collaboration among members</p>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-lg-4">
                                <div class="position-relative h-100 bg-transparent">
                                    <div class="row g-3 my-1">
                                        <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                            <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                                <i class="bi bi-star text-white"></i>
                                            </div>
                                            <div className="col-10 mb-1 mx-2">
                                                <p className="text-uppercase fw-bolder my-0">Best In Industry</p>
                                                <p className="mb-0 my-0">Offer quality & best services</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-3 my-1">
                                        <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                            <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                                <i class="bi bi-briefcase text-white"></i>
                                            </div>
                                            <div className="col-10 mb-1 mx-2">
                                                <p className="text-uppercase fw-bolder my-0">professional experience</p>
                                                <p className="mb-0 my-0">Handy experience in the industry</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-4">
                                <div class="position-relative h-100">
                                    <div class="row g-3 my-1">
                                        <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                            <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                                <i class="bi bi-credit-card text-white"></i>
                                            </div>
                                            <div className="col-10 mb-1 mx-2">
                                                <p className="text-uppercase fw-bolder my-0">affordable pricing</p>
                                                <p className="mb-0 my-0">Cheap & affordable services</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row g-3 my-1">
                                        <div class="col-12 d-flex wow zoomIn" data-wow-delay="0.2s">
                                            <div class="col-2 bg-primary rounded d-flex align-items-center justify-content-center mb-1 mx-2">
                                                <i class="bi bi-tools text-white"></i>
                                            </div>
                                            <div className="col-10 mb-1 mx-2">
                                                <p className="text-uppercase fw-bolder my-0">maintenance services</p>
                                                <p className="mb-0 my-0">After sales and long-term support</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*why us section ends here*/}

                {/*<!--parallax section starts here-->*/}
                <div class="footer-main">
                    <div class="footer-news pad-top-100 pad-bottom-70 parallax">
                        <div class="container">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div class="parallax-div py-5 wow fadeIn" data-wow-duration="1s" data-wow-delay="0.1s">

                                    </div>
                                </div>
                                {/*<!-- end col -->*/}
                            </div>
                            {/*<!-- end row -->*/}
                        </div>
                        {/*<!-- end container -->*/}
                    </div>
                </div>
                {/*<!--parallax section starts here-->*/}

                {/*ICT consultation*/}
                <div class="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                    <div class="container py-5">
                        <div class="row g-5">
                            <div class="col-lg-6">
                                <div class="section-title position-relative pb-3 mb-5">
                                    <h5 class="fw-bold text-primary text-uppercase">consultation services</h5>
                                    <h1 class="text-uppercase mb-0">need to consult? reach us</h1>
                                </div>
                                <p class="mb-4">
                                    We offer professional <strong>ICT consultation services</strong> across various areas of enterprise technology.
                                    Our expertise includes <strong>IT infrastructure management, computer networking, virtualization,
                                        enterprise storage solutions, backup and replication, CCTV surveillance systems, access control,
                                        biometric systems, and comprehensive ICT infrastructure consulting</strong>.
                                </p>

                                <p class="my-4">
                                    Contact us to learn how our ICT solutions can improve the efficiency, security, and reliability of
                                    your business infrastructure. Our services help organizations achieve <strong>business continuity,
                                        high availability, and operational excellence</strong> through reliable networking, proactive
                                    infrastructure management, and 24/7 system support. We also enhance <strong>security and data
                                        protection</strong> by implementing modern surveillance systems, access control solutions, and
                                    resilient backup and disaster recovery strategies to safeguard critical business assets.
                                </p>
                                <div class="d-flex align-items-center mt-2 wow zoomIn" data-wow-delay="0.6s">
                                    <div class="">
                                        <h5 class="my-1">Call or email us to make more inquiries</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="bg-info rounded h-100 d-flex align-items-center p-4 wow zoomIn" data-wow-delay="0.9s">
                                    <form>
                                        <div class="row g-3">
                                            <div class="col-xl-12">
                                                <input type="text" class="form-control bg-light border-0" placeholder="Your Name" />
                                            </div>
                                            <div class="col-12">
                                                <input type="email" class="form-control bg-light border-0" placeholder="Your Email" />
                                            </div>
                                            <div class="col-12">
                                                <select class="form-select bg-light border-0">
                                                    <option selected>Select A Service</option>
                                                    <option value="1">Service 1</option>
                                                    <option value="2">Service 2</option>
                                                    <option value="3">Service 3</option>
                                                </select>
                                            </div>
                                            <div class="col-12">
                                                <textarea class="form-control bg-light border-0" rows="3" placeholder="Message"></textarea>
                                            </div>
                                            <div class="col-12">
                                                <button class="btn my-btn btn-light btn-outline-secondary w-100 py-3" type="submit">Request A Quote</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/*ICT consultation*/}


            </div>
        );
    }
}
